import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrl: './notification-item.component.scss'
})
export class NotificationItemComponent implements OnInit, AfterViewInit {
  @Input() properties!: { moduleId: number, title: string, content: string, date: string, time: string, dateFull: string, url: string, read: boolean, status?: string }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {

  }

  calculateTimePassed(dateTime: string) {
    const period = moment(dateTime);
    const now = moment();
    return moment.duration(now.diff(dateTime)).humanize();
  }
}
